import { createTheme } from "@mui/material";
import { appTypography } from "../../theme/appTypography";

export const DRAWER_WIDTH_FULL = 250;
export const DRAWER_WIDTH_MINI = 82;
export const HEADER_HEIGHT = 70;

export const consultantTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2db838",
      light: "#66bb6a",
      dark: "#0e6346",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#64748b",
      light: "#94a3b8",
      dark: "#475569",
      contrastText: "#ffffff",
    },
    background: { default: "#f4f6f8", paper: "#ffffff" },
    text: { primary: "#212121", secondary: "#757575" },
    divider: "rgba(0, 0, 0, 0.12)",
    action: {
      hover: "rgba(45, 184, 56, 0.08)",
      selected: "rgba(45, 184, 56, 0.12)",
    },
    success: { main: "#4caf50", dark: "#388e3c" },
    warning: { main: "#ff9800" },
    error: { main: "#f44336" },
    info: { main: "#2196f3" },
  },
  typography: {
    ...appTypography,
  },
  shape: { borderRadius: 12 },
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: "1px solid rgba(0,0,0,0.08)" } },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: "#ffffff",
          borderBottom: "1px solid rgba(0,0,0,0.12)",
          color: "#212121",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: "none",
          boxShadow: "2px 0 10px -2px rgba(0,0,0,0.05)",
          backgroundColor: "#ffffff",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          boxShadow: "0 4px 12px -4px rgba(45, 184, 56, 0.5)",
          "&:hover": {
            backgroundColor: "#0e6346",
            boxShadow: "0 6px 16px -4px rgba(45, 184, 56, 0.6)",
          },
        },
        outlinedPrimary: {
          borderColor: "rgba(45, 184, 56, 0.5)",
          color: "#2db838",
          "&:hover": {
            borderColor: "#2db838",
            backgroundColor: "rgba(45, 184, 56, 0.04)",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "#2db838",
          "&:hover": { backgroundColor: "rgba(45, 184, 56, 0.08)" },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: (themeParam) => `
        body { scrollbar-width: thin; scrollbar-color: ${themeParam.palette.primary.dark} ${themeParam.palette.background.default}; }
        /* --- FLASHING ANIMATION --- */
        @keyframes flashYellow {
          0% { opacity: 1; transform: scale(1); text-shadow: 0 0 5px #ffd600; }
          50% { opacity: 0.5; transform: scale(0.9); text-shadow: none; }
          100% { opacity: 1; transform: scale(1); text-shadow: 0 0 5px #ffd600; }
        }
        body::-webkit-scrollbar { width: 8px; }
        body::-webkit-scrollbar-track { background: ${themeParam.palette.background.default}; }
        body::-webkit-scrollbar-thumb { background-color: ${themeParam.palette.primary.dark}; border-radius: 10px; border: 2px solid ${themeParam.palette.background.default}; }
      `,
    },
  },
});
